import { useContext } from 'react'

import { ApacContext } from '../providers/ApacProvider'

export default function useApac() {
  return useContext(ApacContext)
}
